import { css } from "./SKT";

export const SKTInfo = (props) => {
  return (
    <div className={css("row")}>
      <label className={css("col-md-4 control-label")}></label>

      <div className={css("col-md-8 font-13")}>{props.children}</div>
    </div>
  );
};
